import PropertiesDropdown from 'components/PropertiesDropdown/PropertiesDropdown';

export default PropertiesDropdown;
